/**
 * PaymentNotificationQueueService
 * Service for PaymentNotificationQueue entity operations
 * Route: api/payment-notification-queue
 * Controller: PaymentNotificationQueueController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * PaymentNotificationQueueService
 * Handles payment notification queue CRUD operations
 * Maps to /api/payment-notification-queue endpoint
 */
export class PaymentNotificationQueueService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PaymentNotificationQueueService.DEFAULT_SERVICE_PATH,
            basePath: PaymentNotificationQueueService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // Override getById to support GUID
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Payment notification queue with ID ${id} not found`);
        }
        return response.data;
    }
    getByIdRaw(id) {
        const url = this.buildUrl(id);
        return this.http.get(url);
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate payment notification queue cache
     * POST /api/payment-notification-queue/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate payment notification queue cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
PaymentNotificationQueueService.DEFAULT_SERVICE_PATH = 'payments';
PaymentNotificationQueueService.BASE_PATH = 'api/payment-notification-queue';
//# sourceMappingURL=PaymentNotificationQueueService.js.map